import { Button, Fab, Slide, styled, styled as styledMui, useTheme } from "@mui/material";
import { FC } from "react";

import { ArrowSquareOutIcon } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { ArrowUpIcon } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { DOCUMENTATION } from "../../constants/externalLinks";
// These buttons shall be removed in favour of the MUI buttons. Thus, we shouldn't be making making further changes to this file.

const BaseButton = styled("button")`
  display: inline-block;
  margin: 0;
  line-height: 15px;
  vertical-align: middle;
  font-size: 12px;
  text-shadow: none;
  box-shadow: none;
  background-image: none;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid #3883c0;
  cursor: pointer;
  padding: 7px 14px;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  transition: all 0.1s linear;
  > svg {
    margin-right: 10px;
  }
  &:hover {
    text-decoration: none;
    background: #4387bf;
    color: #fff;
    svg {
      color: #fff;
    }
  }
  &[disabled] {
    cursor: not-allowed;
    filter: alpha(opacity=65);
    opacity: 0.65;
  }
`;

const ButtonGroup = styled("div")`
  display: inline-block;
  button {
    margin-right: 10px;
    &:last-child {
      margin-right: inherit;
    }
  }
`;

const BlankButton = styled(BaseButton)`
  color: initial;
  background: initial;
`;

interface ScrollToTopProps {
  onClick: () => void;
}

const ToTop = styledMui(Fab)(({ theme }) => ({
  color: theme.palette.primary.light,
  margin: 0,
  top: "auto",
  right: 20,
  bottom: 20,
  left: "auto",
  position: "fixed",
}));

const ScrollToTop: FC<ScrollToTopProps> = ({ onClick }) => {
  const theme = useTheme();
  return (
    <Slide direction="up" in={true} easing={{ enter: "linear" }}>
      <ToTop size="small" onClick={onClick} data-cy="scrollToTop">
        <ArrowUpIcon color={theme.palette.text30.main} />
      </ToTop>
    </Slide>
  );
};

const DocsButton = () => (
  <Button
    variant="text"
    href={DOCUMENTATION}
    target="_blank"
    rel="noreferrer"
    sx={(theme) => ({
      color: theme.palette.text50.main,
      fontSize: "14px",
      textTransform: "none",
    })}
    endIcon={<ArrowSquareOutIcon size="20px" />}
  >
    Docs
  </Button>
);

export { BlankButton, ButtonGroup, DocsButton, ScrollToTop };
